import { render, staticRenderFns } from "./MainLoader.vue?vue&type=template&id=b7976170&scoped=true"
import script from "./MainLoader.vue?vue&type=script&lang=js"
export * from "./MainLoader.vue?vue&type=script&lang=js"
import style0 from "./MainLoader.vue?vue&type=style&index=0&id=b7976170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7976170",
  null
  
)

export default component.exports